import AjaxRequest from "./AjaxRequest";

export default class Order {
    getStudent(data) {
        return new AjaxRequest().get("student", data);
    }

    checkAccess(data) {
        return new AjaxRequest().post("auth/photoaccess", data);
    }

    checkPhotos(data) {
        return new AjaxRequest().get("photos", data);
    }

    updatePose(data) {
        return new AjaxRequest().patch(
            `photos/${data.film}/${data.frame}`,
            data
        );
    }

    getReceipt(data) {
        return new AjaxRequest().post("order/transaction/receipt", data);
    }

    getUserHistory(data) {
        return new AjaxRequest().get(`user/${data.user_id}/orders`, data);
    }

    updateUsedDiscountCode(data) {
        return new AjaxRequest().patch(`discount/used`, data);
    }

    sendReceiptEmail(data, user_id) {
        return new AjaxRequest().post(`user/${user_id}/receipt/send`, data);
    }
}
